/* Tressential — Cart drawer trigger
 * Wires the header-pro cart icon to open the Dawn cart-drawer instead of /cart,
 * intercepts product form submissions to add to cart via fetch + open the drawer.
 */
(function () {
  function openDrawer(trigger) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      window.location.href = '/cart';
      return;
    }
    if (typeof drawer.open === 'function') {
      drawer.open(trigger);
    } else {
      drawer.classList.add('active', 'animate');
      document.body.classList.add('overflow-hidden');
    }
  }

  function updateCartCount(count) {
    var els = document.querySelectorAll('[data-cart-count]');
    els.forEach(function (el) {
      el.textContent = '(' + count + ')';
    });
  }

  // 1) Cart icon click → open drawer
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-tressential-cart-toggle]');
    if (!trigger) return;
    e.preventDefault();
    openDrawer(trigger);
  });

  // 2) Product form submit → add via fetch, refresh drawer, open it
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

    // Skip if Dawn's product-form web component is already handling it
    var pf = form.closest('product-form');
    if (pf) return;

    e.preventDefault();
    var formData = new FormData(form);
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          console.error(data.description || data.message);
          return;
        }
        if (data.sections && data.sections['cart-drawer']) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
          var newDrawer = doc.querySelector('cart-drawer');
          var oldDrawer = document.querySelector('cart-drawer');
          if (newDrawer && oldDrawer) {
            oldDrawer.innerHTML = newDrawer.innerHTML;
            oldDrawer.classList.remove('is-empty');
          }
        }
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateCartCount(cart.item_count); });
        openDrawer();
      })
      .catch(function (err) { console.error(err); });
  });

  // 3) When Dawn's native product-form fires its update events, refresh count + open drawer
  document.addEventListener('cart:refresh', function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); });
  });

  // 4) Auto-open drawer after Dawn's product-form successful add
  // Dawn's product-form.js dispatches a custom event when the cart is updated.
  document.addEventListener('product:added', function () {
    openDrawer();
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); });
  });
})();
